import React from "react";
import "../App.css";

export default function PrivacyPolicyPage() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "5px", color: "#1f2937" }}>
        Privacy Policy
      </h1>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "20px" }}>
        Last updated: July 28, 2025
      </p>

      <p style={paragraphStyle}>
        At Robito.ai, your privacy and data security are our highest priorities. This
        Privacy Policy explains how we collect, use, and protect your information when you
        use our services. By using Robito.ai, you agree to the terms outlined here.
      </p>

      <h2 style={sectionTitleStyle}>1. Information We Collect</h2>
      <p style={paragraphStyle}>
        We collect only the minimal data needed to provide our automation services, including:
      </p>
      <ul style={listStyle}>
        <li>Your email, name, and company details (for account management and billing).</li>
        <li>App information such as package names and review data (fetched via the official Google Play Developer API).</li>
        <li>Billing and payment information (processed securely by trusted payment gateways).</li>
      </ul>
      <p style={paragraphStyle}>
        **Important:** We do not collect or store Google Play API access tokens. Instead, 
        you grant access by inviting our service account 
        (<strong>robito-service@review-automation-467010.iam.gserviceaccount.com</strong>) 
        to your Google Play Developer Console with the necessary permissions (view app data and reply to reviews).
      </p>

      <h2 style={sectionTitleStyle}>2. How We Use Your Data</h2>
      <p style={paragraphStyle}>
        We use your data solely to:
      </p>
      <ul style={listStyle}>
        <li>Provide review automation services.</li>
        <li>Manage and maintain your account.</li>
        <li>Send essential service-related communications.</li>
        <li>Ensure the reliability and security of our services.</li>
      </ul>

      <h2 style={sectionTitleStyle}>3. Data Security</h2>
      <p style={paragraphStyle}>
        We implement strict security measures, including encryption and access controls,
        to safeguard your data against unauthorized access or disclosure. Since we do not
        store API tokens, your Google Play developer account credentials remain fully
        under your control.
      </p>

      <h2 style={sectionTitleStyle}>4. Data Sharing</h2>
      <p style={paragraphStyle}>
        We never sell your personal data. We may share information only when:
      </p>
      <ul style={listStyle}>
        <li>Required by law, regulation, or legal process.</li>
        <li>Necessary for payment processing with trusted third-party providers (e.g., Xendit).</li>
      </ul>

      <h2 style={sectionTitleStyle}>5. Your Rights</h2>
      <p style={paragraphStyle}>
        You may request access, correction, or deletion of your personal information
        by contacting us at <strong>developer@robito.ai</strong>.
      </p>

      <h2 style={sectionTitleStyle}>6. Changes to This Privacy Policy</h2>
      <p style={paragraphStyle}>
        We may update this Privacy Policy from time to time. Any changes will be
        communicated on this page, and continued use of our services means you accept
        the updated policy.
      </p>

      <h2 style={sectionTitleStyle}>7. Contact Us</h2>
      <p style={paragraphStyle}>
        If you have any privacy-related questions, please contact us at
        <strong> developer@robito.ai</strong>.
      </p>
    </div>
  );
}

const paragraphStyle = {
  fontSize: "1rem",
  color: "#4b5563",
  marginBottom: "20px",
  lineHeight: "1.6",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  fontWeight: "600",
  marginBottom: "10px",
  color: "#1f2937",
};

const listStyle = {
  marginLeft: "20px",
  color: "#4b5563",
  fontSize: "1rem",
  lineHeight: "1.6",
  marginBottom: "20px"
};
